import {
  /* City,  */
  // ParagraphPaternCourse,
  // InCourses,
  CoursesContainer /* TheatersSection */,
} from "./styles";

import img from "../../images/cursos.png";
import { ParagraphPatern, TitleSectionsPatern } from "../../App";
import Contacts from "../../components/Contacts";
// import InTheaters from "../../components/InTheaters";
// import circo from "../../imagesTheaters/circo.jpg";
// import cursos2 from "../../images/cursos2.jpg";
// import curso_iniciacao from "../../images/curso_iniciacao.png";
const Courses = () => {
  return (
    <CoursesContainer>
      <img src={img} alt="Misenscene Cursos" />
      <TitleSectionsPatern>Descrição</TitleSectionsPatern>
      <ParagraphPatern>
        As aulas de teatro auxiliam no desenvolvimento do indivíduo em muitos
        aspectos, individuais e coletivos, onde aprendem a desenvolver sua
        criatividade, expressões artísticas e o trabalho em grupo, além de
        ajudar na autoestima e empatia. <br></br>
        Realizamos cursos para crianças, jovens e adultos, todas as aulas são
        preparadas de maneiras distintas, dependendo da faixa etária dos alunos
        e como elas se adaptam as propostas. Nelas estimulamos para que o aluno
        passe a desenvolver a atenção, concentração, observação e criatividade,
        além de conhecer a linguagem teatral, que é nosso principal objetivo.
      </ParagraphPatern>

      {/* <InCourses>
        <img src={curso_iniciacao} alt={"Curso de Iniciação Teatral"}></img>
        <h3>🎭 Curso de Iniciação Teatral 🎭</h3>
        <h2>
          Venha experienciar a arte teatral no nosso curso de teatro para
          iniciantes!
        </h2>
        <ParagraphPaternCourse>
          📍 Local: Rua Caramuru, 117 – Bairro Barrinha, São Lourenço do Sul
        </ParagraphPaternCourse>
        <ParagraphPaternCourse>
          📆 Datas: De 28 de julho a 1º de agosto
        </ParagraphPaternCourse>
        <ParagraphPaternCourse>
          ⏰ Horário: Das 18h30 às 20h30{" "}
        </ParagraphPaternCourse>
        <ParagraphPaternCourse>📚 Duração: 5 aulas</ParagraphPaternCourse>
        <ParagraphPaternCourse>
          🎭 Participação em um espetáculo teatral no último dia de aula
        </ParagraphPaternCourse>
        <ParagraphPaternCourse>
          💸 Investimento: R$ 150,00 a vista ou 2x de R$ 100,00.
        </ParagraphPaternCourse>
        <ParagraphPaternCourse>
          👥 Turma mínima para realização do curso: 5 alunos 🎓 Ministrante:
          Ator e Diretor Lucas Lopes
        </ParagraphPaternCourse>
        <ParagraphPaternCourse>
          🗣️ Aulas dinâmicas e criativas para quem quer dar os primeiros passos
          no teatro, perder a timidez, explorar a imaginação e se expressar com
          liberdade!
        </ParagraphPaternCourse>
        <ParagraphPaternCourse>
          🔸 Inscrições e informações pelo
        </ParagraphPaternCourse>
        <ParagraphPaternCourse>
          📞 WhatsApp:{" "}
          <a
            href={`https://api.whatsapp.com/send?phone=5553981119125&text=Olá, queria informações sobre o Curso de Iniciação Teatral`}
            target={"_blank"}
            rel="noreferrer"
          >
            (53) 98111-9125
          </a>
        </ParagraphPaternCourse>
      </InCourses> */}
      <h3>Em breve novas turmas</h3>
      <Contacts subject={"Cursos"} />
    </CoursesContainer>
  );
};

export default Courses;
